<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="query"
              type="search"
              :placeholder="'Search here...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l("INDEX.btn_add") || "新增" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" label-width="110px" :model="form" size="medium">
        <el-form-item :label="$l('table_head_chineseName') || '中文名称'">
          <el-input
            v-model="form.prjCategoryName"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
            clearable
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$l('table_head_englishName') || '英文名称'">
          <el-input
            v-model="form.prjCategoryEnName"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
            clearable
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$l('INDEX.Status') || '状态'">
          <el-checkbox-group v-model="form.prjCategoryStatusList">
            <el-checkbox label="Y">{{
              $l("INDEX.form_label_valid") || "有效"
            }}</el-checkbox>
            <el-checkbox label="N">{{
              $l("INDEX.form_label_invalid") || "无效"
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$l('table_label_isSampleName') || '是否打样'">
          <el-checkbox-group v-model="form.isSampleList">
            <el-checkbox label="Y">{{ $l("INDEX.YES") || "是" }}</el-checkbox>
            <el-checkbox label="N">{{ $l("INDEX.NO") || "否" }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter ") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  searchKey: "",
  prjCategoryName: "",
  prjCategoryEnName: "",
  prjCategoryStatusList: ["Y"],
  isSampleList:["Y","N"],
};

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    query() {
      this.$emit("submit", this.form);
    },
    onReset() {
      this.form = {
        ...initForm,
      };
      this.$emit("reset");
      this.query();
    },
    fromLoad() {
      this.$emit("add");
    },
    // 高级查询
    advquery() {
      this.form.searchKey = "";
      this.query();
      this.closeAdvqueryDialog();
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm };
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true;
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false;
    },
  },
  mounted() {
    this.query();
  },
  activated() {
    this.query();
  },
};
</script>
